import { AboyeurPluginNamed } from '@ifood/aboyeur';
import ReactGA from 'react-ga4';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var _excluded = ["trackingIds", "metadata"];
var NAME = 'Google Analytics';
var ERROR = {
  CONFIG: "Misconfigured " + NAME + " plugin metadata"
};
var MANDATORY_GA_CONFIG_KEYS = ['trackingIds'];
function isGoogleAnalyticsMetaData(metadata) {
  if (!('googleAnalytics' in metadata)) {
    return false;
  }
  var googleAnalytics = metadata.googleAnalytics;
  if (typeof googleAnalytics !== 'object' || !googleAnalytics) {
    return false;
  }
  return MANDATORY_GA_CONFIG_KEYS.every(function (key) {
    return Object.prototype.hasOwnProperty.call(googleAnalytics, key);
  });
}
var GoogleAnalyticsPlugin = /*#__PURE__*/function (_AboyeurPluginNamed) {
  _inheritsLoose(GoogleAnalyticsPlugin, _AboyeurPluginNamed);
  function GoogleAnalyticsPlugin() {
    return _AboyeurPluginNamed.apply(this, arguments) || this;
  }
  var _proto = GoogleAnalyticsPlugin.prototype;
  _proto.initialize = function initialize() {
    var metadata = this.metadata;
    if (!isGoogleAnalyticsMetaData(metadata)) {
      throw new Error(ERROR.CONFIG);
    }
    var _metadata$googleAnaly = metadata.googleAnalytics,
      trackingIds = _metadata$googleAnaly.trackingIds,
      initializeOptions = _objectWithoutPropertiesLoose(_metadata$googleAnaly, _excluded);
    ReactGA.initialize(trackingIds.map(function (id) {
      return _extends({
        trackingId: id
      }, initializeOptions);
    }, {
      alwaysSendToDefaultTracker: false
    }));
  };
  _proto.sendEvent = function sendEvent(options) {
    var label = options.label,
      entity = options.entity,
      feature = options.feature,
      metadata = options.metadata;
    var _metadata$event = metadata.event,
      value = _metadata$event.value,
      nonInteraction = _metadata$event.nonInteraction,
      path = _metadata$event.path;
    if (typeof path === 'string') {
      ReactGA.send('pageview');
    }
    ReactGA.event(_extends({
      category: entity,
      action: String(feature),
      label: label
    }, typeof value === 'number' && {
      value: value
    }, nonInteraction !== undefined && {
      nonInteraction: Boolean(nonInteraction)
    }));
  };
  _proto.onMetadataChange = function onMetadataChange() {
    if (!isGoogleAnalyticsMetaData(this.metadata)) {
      return;
    }
    var googleAnalytics = this.metadata.googleAnalytics;
    if (!googleAnalytics.metadata) {
      return;
    }
    var metadata = googleAnalytics.metadata;
    ReactGA.set(metadata);
  };
  return GoogleAnalyticsPlugin;
}( /*#__PURE__*/AboyeurPluginNamed(NAME));

export { GoogleAnalyticsPlugin };
//# sourceMappingURL=aboyeur-plugin-ga.esm.js.map
